import React, { useState, useRef, useEffect } from 'react';
import ReactToPrint from "react-to-print";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import CSConfigUtil from '../../util/CSConfigUtil';
import CSServiceUtil from '../../util/CSServiceUtil';
import CSRequestUtil from '../../util/CSRequestUtil';
import CSUtil from "../../util/CSUtil";

const mServiceUtil = CSServiceUtil.cfGetInstance();

const CSHallTicket1 = (lProps) => {
    const mComponentRef = useRef(null);
    const [mHeaderTitle, setHeaderTitle] = useState('GOWTHAM WORLD SCHOOL');
    const [mExamDataField, setExamDataField] = useState('');
    const [mStudentDetails, setStudentDetails] = useState(
        {
            mStudentName: '',
            mCompanyLogo: '',
            mClassName: '',
            mAdmissionNo: '',
            mSection: ''
        }, []
    );

    const [mExamDetails, setExamDetails] = useState({}, []);

    const [mTop1Section1, setTop1Section1] = useState({}, []);
    const [mTop1Section2, setTop1Section2] = useState({}, []);
    const [mStudentHeaderMap, setStudentHeaderMap] = useState(null);
    const [mExamScheduleMap, setExamScheduleMap] = useState();

    const [mServiceCode, setServiceCode] = useState(null);
    const [mRequestId, setRequestId] = useState(null);
    const [mCriteriaParams, setCriteriaParams] = useState(null);
    const [mDataTableLabelData, setDataTableLabelData] = useState(null);
    const [mDataTableDateField, setDataTableDateField] = useState(null);

    const [mFooter, setFooter] = useState("It is mandatory to carry the hall ticket for all examinations.");

    useEffect(() => {
        const fnInitializeForm = () => {
            if (lProps && lProps.pFormProperties) {
                let lCriteriaParams = null;
                let lDataTableLabelData = null;
                let lDataTableDataField = null;
                for (let lInd = 0; lInd < lProps.pFormProperties.length; lInd++) {
                    let lPropObj = lProps.pFormProperties[lInd];
                    const lValue = lPropObj.value_;
                    if (lPropObj.type_ === 'initialize') {
                        if (lPropObj.property_ === 'heading_1_') {
                            setHeaderTitle(lValue);
                        }
                        else if (lPropObj.property_ === 'heading_2_') {
                            setStudentDetails(lPrevState => { return { ...lPrevState, mTitle: lValue } });
                        }
                        else if (lPropObj.property_ === 'heading_3_data_field_') {
                            setExamDataField(lValue);
                        }
                        else if (lPropObj.property_ === 'footer_') {
                            setFooter(lValue);
                        }
                        else if (lPropObj.property_ === 'logo_') {
                            setStudentDetails(lPrevState => { return { ...lPrevState, mCompanyLogo: lValue } });
                        }
                    }
                    else if (lPropObj.type_ === 'header') {
                        if (lPropObj.property_ === 'section_1_label_column_1_') {
                            setTop1Section1(lPrevState => { return { ...lPrevState, column_1_label_: lValue } });
                        }
                        else if (lPropObj.property_ === 'section_1_label_column_2_') {
                            setTop1Section1(lPrevState => { return { ...lPrevState, column_2_label_: lValue } });
                        }
                        else if (lPropObj.property_ === 'section_1_label_column_3_') {
                            setTop1Section1(lPrevState => { return { ...lPrevState, column_3_label_: lValue } });
                        }
                        else if (lPropObj.property_ === 'section_1_label_column_4_') {
                            setTop1Section1(lPrevState => { return { ...lPrevState, column_4_label_: lValue } });
                        }
                        else if (lPropObj.property_ === 'section_1_data_field_column_1_') {
                            setTop1Section1(lPrevState => { return { ...lPrevState, column_1_data_field_: lValue } });
                        }
                        else if (lPropObj.property_ === 'section_1_data_field_column_2_') {
                            setTop1Section1(lPrevState => { return { ...lPrevState, column_2_data_field_: lValue } });
                        }
                        else if (lPropObj.property_ === 'section_1_data_field_column_3_') {
                            setTop1Section1(lPrevState => { return { ...lPrevState, column_3_data_field_: lValue } });
                        }
                        else if (lPropObj.property_ === 'section_1_data_field_column_4_') {
                            setTop1Section1(lPrevState => { return { ...lPrevState, column_4_data_field_: lValue } });
                        }
                        else if (lPropObj.property_ === 'section_2_label_column_1_') {
                            setTop1Section2(lPrevState => { return { ...lPrevState, column_1_label_: lValue } });
                        }
                        else if (lPropObj.property_ === 'section_2_label_column_2_') {
                            setTop1Section2(lPrevState => { return { ...lPrevState, column_2_label_: lValue } });
                        }
                        else if (lPropObj.property_ === 'section_2_label_column_3_') {
                            setTop1Section2(lPrevState => { return { ...lPrevState, column_3_label_: lValue } });
                        }
                        else if (lPropObj.property_ === 'section_2_label_column_4_') {
                            setTop1Section2(lPrevState => { return { ...lPrevState, column_4_label_: lValue } });
                        }
                        else if (lPropObj.property_ === 'section_2_data_field_column_1_') {
                            setTop1Section2(lPrevState => { return { ...lPrevState, column_1_data_field_: lValue } });
                        }
                        else if (lPropObj.property_ === 'section_2_data_field_column_2_') {
                            setTop1Section2(lPrevState => { return { ...lPrevState, column_2_data_field_: lValue } });
                        }
                        else if (lPropObj.property_ === 'section_2_data_field_column_3_') {
                            setTop1Section2(lPrevState => { return { ...lPrevState, column_3_data_field_: lValue } });
                        }
                        else if (lPropObj.property_ === 'section_2_data_field_column_4_') {
                            setTop1Section2(lPrevState => { return { ...lPrevState, column_4_data_field_: lValue } });
                        }
                    }
                    else if (lPropObj.type_ === 'criteria') {
                        if(!lCriteriaParams){
                            lCriteriaParams = {}
                        }

                        lCriteriaParams[lPropObj.property_] = lPropObj.value_;
                    }
                    else if(lPropObj.type_ === 'data_table') {
                        if(lPropObj.group_ === 'label') {
                            if(!lDataTableLabelData) {
                                lDataTableLabelData = {}
                            }
        
                            lDataTableLabelData[lPropObj.property_] = lPropObj.value_;
                        }
                        else if(lPropObj.group_ === 'data_field') {
                            if(!lDataTableDataField) {
                                lDataTableDataField = {}
                            }
        
                            lDataTableDataField[lPropObj.property_] = lPropObj.value_;                          
                        }
                    }
                }

                setDataTableLabelData(lDataTableLabelData);
                setDataTableDateField(lDataTableDataField);

                if ((lCriteriaParams || lProps.pCriteria) && lProps.pSelectedActionItem) {
                    setCriteriaParams(lCriteriaParams);
                    setRequestId(lProps.pSelectedActionItem.request_id_);
                    setServiceCode(lProps.pSelectedActionItem.on_click_service_code_);
                }
            }
        }

        fnInitializeForm();
    }, [lProps, setExamDetails, setStudentDetails]
    );

    useEffect(() => {
        const fnInitializeData = () => {
            if (mServiceCode && lProps.pCriteria) {
                let lServiceObject = mServiceUtil.cfGetServiceObject(mServiceCode);
                if (lServiceObject) {
                    let lCriteria = lProps.pCriteria;
                    lCriteria.office_code_ = CSConfigUtil.mOfficeCode;

                    if(mCriteriaParams) {
                        let lDataObject = null;
                        let lDataField = null;
                        let lType = null;
                        let lCriteriaField = null;
                        let lCriteriaData = null;
                        if(mCriteriaParams.hasOwnProperty('data_object_') 
                            && lProps.hasOwnProperty('pSelectedData') 
                            && lProps.pSelectedData.hasOwnProperty(mCriteriaParams['data_object_'])) {
                            lDataObject = lProps.pSelectedData[mCriteriaParams['data_object_']];
                        }

                        if(mCriteriaParams.hasOwnProperty('data_field_')) {
                            lDataField = mCriteriaParams['data_field_'];
                        }

                        if(mCriteriaParams.hasOwnProperty('type_')) {
                            lType = mCriteriaParams['type_'];
                        }

                        if(mCriteriaParams.hasOwnProperty('criteria_field_')) {
                            lCriteriaField = mCriteriaParams['criteria_field_'];
                        }
                        else if(lDataField){
                            lCriteriaField = lDataField;
                        }

                        if(lDataObject && lDataField) {
                            if(lDataObject instanceof Array) {
                                for(let lInd=0; lInd<lDataObject.length; lInd++){
                                    let lObj = lDataObject[lInd];
                                    if(lObj.hasOwnProperty(lDataField)) {
                                        if(!lCriteriaData) {
                                            lCriteriaData = "'" + lObj[lDataField] + "'";
                                        }
                                        else {
                                            if(lType === 'CONCAT'){
                                                lCriteriaData = lCriteriaData + "," + "'" + lObj[lDataField] + "'";
                                            }
                                        }
                                    }
                                }
                            }

                            if(lCriteriaData && lCriteriaField) {
                                lCriteria[lCriteriaField] = lCriteriaData;
                            }
                        }
                    }

                    let lRequestUtil = new CSRequestUtil('GET', mServiceCode, lServiceObject.type_, mRequestId, lServiceObject);
                    lRequestUtil.cfSetRequestCriteria(lCriteria);
                    lRequestUtil.cfProcessRequest((lResponse) => {
                        if (lResponse) {
                            let lStudentHeaderMap = {};
                            if (lResponse.hasOwnProperty('student_details_') && (lResponse.student_details_.length > 0)) {
                                for (let lInd = 0; lInd < lResponse.student_details_.length; lInd++) {
                                    let lStudentDetailsHeader = CSUtil.cfGetObjectCopy(lResponse.student_details_[lInd]);
                                    let lHeaderObj = lStudentHeaderMap[lStudentDetailsHeader.admission_no_];
                                    if (!lHeaderObj) {
                                        lStudentHeaderMap[lStudentDetailsHeader.admission_no_] = lStudentDetailsHeader;
                                    }
                                }

                                setStudentHeaderMap(lStudentHeaderMap);
                            }

                            if(mDataTableLabelData && mDataTableDateField) {
                                let lExamScheduleMap = {};
                                if (lResponse.hasOwnProperty('exam_schedule_') && (lResponse.exam_schedule_.length > 0)) {
                                    for (let lpInd = 0; lpInd < lResponse.exam_schedule_.length; lpInd++) {
                                        let lScheduleObj = lResponse.exam_schedule_[lpInd];
                                        let lExamScheduleList = lExamScheduleMap[lScheduleObj.admission_no_];
                                        if (!lExamScheduleList) {
                                            lExamScheduleList = [];
                                            lExamScheduleMap[lScheduleObj.admission_no_] = lExamScheduleList;
                                        }
    
                                        lExamScheduleList.push(lScheduleObj);
                                    }
                                }
                          
                                setExamScheduleMap(lExamScheduleMap); 
                            }
                        }
                    }
                    );
                }
            }
        }

        fnInitializeData();
    }, [mServiceCode, mRequestId, lProps, lProps.pCriteria, mCriteriaParams, mDataTableDateField, mDataTableLabelData]
    );

    let lHeaderActions = [];
    lHeaderActions.push(
        <ReactToPrint
            key="1"
            trigger={() =>
                <Button
                    style=
                    {
                        {
                            fontSize: '13.2px',
                            marginRight: '.35em',
                            width: '24px',
                            height: '24px',
                            verticalAlign: 'middle'
                        }
                    }
                    type="Button"
                    icon={CSUtil.mNameIconMap['PI_PRINT']}
                />
            }
            content={() => mComponentRef.current}
        />
    );

    lHeaderActions.push(
        <Button
            key="2"
            style=
            {
                {
                    fontSize: '13.2px',
                    marginRight: '.35em',
                    width: '24px',
                    height: '24px',
                    verticalAlign: 'middle'
                }
            }
            type="Button"
            icon={CSUtil.mNameIconMap['PI_TIMES']}
            onClick={() => (lProps.fnProcessClose) ? lProps.fnProcessClose(false) : null}
        />
    );

    let lHeader =
        <>
            <div className="p-toolbar-group-left">
                <h2>{lProps.pFormHeading}</h2>
            </div>

            <div className="p-toolbar-group-right">
                {lHeaderActions}
            </div>
        </>

    let lForm = null;
    if (mStudentHeaderMap) {
        let lStudentList = Object.keys(mStudentHeaderMap);
        for (let lInd = 0; lInd < lStudentList.length; lInd++) {
            let lTableHeading = [];
            let lRowData1 = [];
            let lRowData2 = [];
            let lRowData = []
    
            let lStudentHeaderObject = mStudentHeaderMap[lStudentList[lInd]];
            let lExamName = null;

            if(mExamDataField && lStudentHeaderObject.hasOwnProperty(mExamDataField)) {
                lExamName = lStudentHeaderObject[mExamDataField];
            }
            /**
             * Top Section 1
             * Column 1
             */
            let lTop1Section1Column1 = null;
            if (mTop1Section1 && mTop1Section1.hasOwnProperty('column_1_label_')) {
                let lLabel = mTop1Section1.column_1_label_;
                let lData = '';
                if (lStudentHeaderObject && mTop1Section1.hasOwnProperty('column_1_data_field_') && lStudentHeaderObject.hasOwnProperty(mTop1Section1.column_1_data_field_)) {
                    lData = lStudentHeaderObject[mTop1Section1.column_1_data_field_];
                }

                lTop1Section1Column1 =
                    <div className="form-item-row">
                        <div style={{ width: '150px', fontWeight: 'bold' }}>{lLabel}</div>
                        <div style={{ width: '25px', fontWeight: 'bold' }}>:&nbsp;&nbsp;</div>
                        <div style={{ width: '80%' }}>{lData}</div>
                    </div>
            }

            /**
             * Top Section 1
             * Column 2
             */
            let lTop1Section1Column2 = null;
            if (mTop1Section1 && mTop1Section1.hasOwnProperty('column_2_label_')) {
                let lLabel = mTop1Section1.column_2_label_;
                let lData = '';
                if (lStudentHeaderObject && mTop1Section1.hasOwnProperty('column_2_data_field_') && lStudentHeaderObject.hasOwnProperty(mTop1Section1.column_2_data_field_)) {
                    lData = lStudentHeaderObject[mTop1Section1.column_2_data_field_];
                }

                lTop1Section1Column2 =
                    <div className="form-item-row">
                        <div style={{ width: '150px', fontWeight: 'bold' }}>{lLabel}</div>
                        <div style={{ width: '25px', fontWeight: 'bold' }}>:&nbsp;&nbsp;</div>
                        <div style={{ width: '80%' }}>{lData}</div>
                    </div>
            }

            /**
             * Top Section 1
             * Column 3
             */
            let lTop1Section1Column3 = null;
            if (mTop1Section1 && mTop1Section1.hasOwnProperty('column_3_label_')) {
                let lLabel = mTop1Section1.column_3_label_;
                let lData = '';
                if (lStudentHeaderObject && mTop1Section1.hasOwnProperty('column_3_data_field_') && lStudentHeaderObject.hasOwnProperty(mTop1Section1.column_3_data_field_)) {
                    lData = lStudentHeaderObject[mTop1Section1.column_3_data_field_];
                }

                lTop1Section1Column3 =
                    <div className="form-item-row">
                        <div style={{ width: '150px', fontWeight: 'bold' }}>{lLabel}</div>
                        <div style={{ width: '25px', fontWeight: 'bold' }}>:&nbsp;&nbsp;</div>
                        <div style={{ width: '80%' }}>{lData}</div>
                    </div>
            }

            /**
             * Top Section 1
             * Column 4
             */
            let lTop1Section1Column4 = null;
            if (mTop1Section1 && mTop1Section1.hasOwnProperty('column_4_label_')) {
                let lLabel = mTop1Section1.column_4_label_;
                let lData = '';
                if (lStudentHeaderObject && mTop1Section1.hasOwnProperty('column_4_data_field_') && lStudentHeaderObject.hasOwnProperty(mTop1Section1.column_4_data_field_)) {
                    lData = lStudentHeaderObject[mTop1Section1.column_4_data_field_];
                }

                lTop1Section1Column4 =
                    <div className="form-item-row">
                        <div style={{ width: '150px', fontWeight: 'bold' }}>{lLabel}</div>
                        <div style={{ width: '25px', fontWeight: 'bold' }}>:&nbsp;&nbsp;</div>
                        <div style={{ width: '80%' }}>{lData}</div>
                    </div>
            }

            /**
             * Top Section 2
             * Column 1
             */
            let lTop1Section2Column1 = null;
            if (mTop1Section2 && mTop1Section2.hasOwnProperty('column_1_label_')) {
                let lLabel = mTop1Section2.column_1_label_;
                let lData = '';
                if (lStudentHeaderObject && mTop1Section2.hasOwnProperty('column_1_data_field_') && lStudentHeaderObject.hasOwnProperty(mTop1Section2.column_1_data_field_)) {
                    lData = lStudentHeaderObject[mTop1Section2.column_1_data_field_];
                }

                lTop1Section2Column1 =
                    <div className="form-item-row">
                        <div style={{ width: '150px', fontWeight: 'bold' }}>{lLabel}</div>
                        <div style={{ width: '25px', fontWeight: 'bold' }}>:&nbsp;&nbsp;</div>
                        <div style={{ width: '80%' }}>{lData}</div>
                    </div>
            }

            /**
             * Top Section 2
             * Column 2
             */
            let lTop1Section2Column2 = null;
            if (mTop1Section2 && mTop1Section2.hasOwnProperty('column_2_label_')) {
                let lLabel = mTop1Section2.column_2_label_;
                let lData = '';
                if (lStudentHeaderObject && mTop1Section2.hasOwnProperty('column_2_data_field_') && lStudentHeaderObject.hasOwnProperty(mTop1Section2.column_2_data_field_)) {
                    lData = lStudentHeaderObject[mTop1Section2.column_2_data_field_];
                }

                lTop1Section2Column2 =
                    <div className="form-item-row">
                        <div style={{ width: '150px', fontWeight: 'bold' }}>{lLabel}</div>
                        <div style={{ width: '25px', fontWeight: 'bold' }}>:&nbsp;&nbsp;</div>
                        <div style={{ width: '80%' }}>{lData}</div>
                    </div>
            }

            /**
             * Top Section 2
             * Column 3
             */
            let lTop1Section2Column3 = null;
            if (mTop1Section2 && mTop1Section2.hasOwnProperty('column_3_label_')) {
                let lLabel = mTop1Section2.column_3_label_;
                let lData = '';
                if (lStudentHeaderObject && mTop1Section2.hasOwnProperty('column_3_data_field_') && lStudentHeaderObject.hasOwnProperty(mTop1Section2.column_3_data_field_)) {
                    lData = lStudentHeaderObject[mTop1Section2.column_3_data_field_];
                }

                lTop1Section2Column3 =
                    <div className="form-item-row">
                        <div style={{ width: '150px', fontWeight: 'bold' }}>{lLabel}</div>
                        <div style={{ width: '25px', fontWeight: 'bold' }}>:&nbsp;&nbsp;</div>
                        <div style={{ width: '80%' }}>{lData}</div>
                    </div>
            }

            /**
             * Top Section 2
             * Column 4
             */
            let lTop1Section2Column4 = null;
            if (mTop1Section2 && mTop1Section2.hasOwnProperty('column_4_label_')) {
                let lLabel = mTop1Section2.column_4_label_;
                let lData = '';
                if (lStudentHeaderObject && mTop1Section2.hasOwnProperty('column_4_data_field_') && lStudentHeaderObject.hasOwnProperty(mTop1Section2.column_4_data_field_)) {
                    lData = lStudentHeaderObject[mTop1Section2.column_4_data_field_];
                }

                lTop1Section2Column4 =
                    <div className="form-item-row">
                        <div style={{ width: '150px', fontWeight: 'bold' }}>{lLabel}</div>
                        <div style={{ width: '25px', fontWeight: 'bold' }}>:&nbsp;&nbsp;</div>
                        <div style={{ width: '80%' }}>{lData}</div>
                    </div>
            }

            let lTop1 =
                <div className="summary">
                    <div className="summary-1">
                        {lTop1Section1Column1}
                        {lTop1Section1Column2}
                        {lTop1Section1Column3}
                        {lTop1Section1Column4}
                    </div>

                    <div className="summary-2">
                        {lTop1Section2Column1}
                        {lTop1Section2Column2}
                        {lTop1Section2Column3}
                        {lTop1Section2Column4}
                    </div>
                </div>

            let lTmpForm = null;
            let lExamScheduleDetails = null;
            if(mExamScheduleMap) {
                lExamScheduleDetails = mExamScheduleMap[lStudentList[lInd]]
            }

            if(lExamScheduleDetails && lExamScheduleDetails.length > 0){
                let lTmpInd = 0;
                let lHeaderColumnName = '';
                let lHeaderDataField = '';
                if(mDataTableLabelData && mDataTableLabelData.hasOwnProperty('table_row_1_column_1_') && mDataTableDateField && mDataTableDateField.hasOwnProperty('table_row_1_data_field_')) {
                    lHeaderColumnName = mDataTableLabelData['table_row_1_column_1_'];
                    lTableHeading.push(<th key={lInd + 1}> { lHeaderColumnName } </th>);

                    lHeaderDataField = mDataTableDateField['table_row_1_data_field_'];            
                    lTmpInd = lTmpInd + (lInd + 1) * 1000;
                    for(let lSchInd=0; lSchInd<lExamScheduleDetails.length; lSchInd++) {
                        let lScheduleObj = lExamScheduleDetails[lSchInd];
                        if(lScheduleObj.hasOwnProperty(lHeaderDataField)) {
                            lTableHeading.push(<th key={lTmpInd++}> { lScheduleObj[lHeaderDataField] } </th>);
                        }
                    }
                }

                let lRowData1ColumnName = '';
                let lRowData1DataField = '';
                if(mDataTableLabelData && mDataTableLabelData.hasOwnProperty('table_row_2_column_1_') && mDataTableDateField && mDataTableDateField.hasOwnProperty('table_row_2_data_field_')) {
                    lRowData1ColumnName = mDataTableLabelData['table_row_2_column_1_'];
                    lRowData1.push(<td key={lTmpInd++}> { lRowData1ColumnName } </td>);
    
                    lRowData1DataField = mDataTableDateField['table_row_2_data_field_'];   
                    for(let lSchInd=0; lSchInd<lExamScheduleDetails.length; lSchInd++) {
                        let lScheduleObj = lExamScheduleDetails[lSchInd];
                        if(lScheduleObj.hasOwnProperty(lRowData1DataField)) {
                            lRowData1.push(<td key={lTmpInd++}> { lScheduleObj[lRowData1DataField] } </td>);
                        }
                        else {
                            lRowData1.push(<td key={lTmpInd++}></td>);
                        }
                    }

                    lRowData.push(<tr key={lTmpInd++}>{lRowData1}</tr>);
                }

                let lRowData2ColumnName = '';
                let lRowData2DataField = '';
                if(mDataTableLabelData && mDataTableLabelData.hasOwnProperty('table_row_3_column_1_') && mDataTableDateField && mDataTableDateField.hasOwnProperty('table_row_3_data_field_')) {
                    lRowData2ColumnName = mDataTableLabelData['table_row_3_column_1_'];
                    lRowData2.push(<td key={lTmpInd++}> { lRowData2ColumnName } </td>);
    
                    lRowData2DataField = mDataTableDateField['table_row_3_data_field_'];   
                    for(let lSchInd=0; lSchInd<lExamScheduleDetails.length; lSchInd++) {
                        let lScheduleObj = lExamScheduleDetails[lSchInd];
                        if(lScheduleObj.hasOwnProperty(lRowData2DataField)) {
                            lRowData2.push(<td key={lTmpInd++}> { lScheduleObj[lRowData1DataField] } </td>);
                        }
                        else {
                            lRowData2.push(<td key={lTmpInd++}></td>);
                        }
                    }

                    lRowData.push(<tr key={lTmpInd++}>{lRowData2}</tr>);
                }
            }

            lTmpForm =
                <div className="hall-ticket-1">
                    <div style={{ minWidth: '600px' }}>
                        <div className="header-1">
                            <img alt='Logo' className="logo" src={mStudentDetails.mCompanyLogo} width={'100%'}/>
                            
                            <div className="heading"> 
                                <h1>{mHeaderTitle}</h1>
                                <h2>{mStudentDetails.mTitle}</h2>
                                <h2>{lExamName}</h2>
                            </div>

                            <img alt='Seal' className="seal" src="./images/circle-stamp-png-5.png"/>
                        </div>

                        <main className='ht-layout'>
                            <div className="marks-details">
                                {lTop1}
                            </div>

                            <table className="items">
                                <thead>
                                    <tr>{lTableHeading}</tr>
                                </thead>

                                <tbody>
                                    {lRowData}
                                </tbody>
                            </table>
                        </main>

                        <footer style={{fontSize:12}}>
                            <div className="footer-1"> 
                                <div style={{width: '50%', fontWeight: 'bold', textAlign: "start"}}>Class Teacher</div>
                                <div style={{width: '50%', fontWeight: 'bold', textAlign: "end"}}>Principal</div>
                            </div>

                            {mFooter}
                        </footer>
                    </div>

                    <div></div>
                </div>

            if (lForm === null) {
                lForm = lTmpForm;
            }
            else if((lInd > 2) && ((lInd) % 3) === 0){
                lForm =
                    <>
                        {lForm}
                        <div className="page-break" />
                        {lTmpForm}
                    </>
            }
            else {
                lForm =
                    <>
                        {lForm}
                        {lTmpForm}
                    </>
            }
        }
    }

    return (
        <Dialog
            visible    = {true}
            minHeight  = 'auto'
            closable   = {false}
            header     = {lHeader}
            appendTo   = {document.body}
            onHide={() => (lProps.fnProcessClose) ? lProps.fnProcessClose() : null}>
            <div ref = {mComponentRef}
                style = 
                {
                    {
                        margin : '5px'
                    }
                }
            >
                {lForm}
            </div>
        </Dialog>
    );
}

export default CSHallTicket1;